import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';

import './DialogsWithIcon.scss';

export default function DialogsWithIcon(props) {
  const {
    header,
    children,
    character,
    layoutType = 'info',
    headerClassName,
    footerClassName,
    contentClassName,
    headerTitleClassName,
    headerTitleIconClassName,
    noBorder = true,
    preHeader,
    noContent,
  } = props;

  return (
    <GeneralDialogLayout
      {...props}
      headerClassName={classnames(headerClassName, { 'rx-border-none': noBorder })}
      footerClassName={classnames(footerClassName, { 'rx-border-none': noBorder })}
      header={
        <>
          {preHeader}
          <div className="dialog-with-icon-layout-header-wrapper">
            <div
              className={classnames(
                headerTitleIconClassName,
                'dialog-with-icon-layout-header-icon',
                `dialog-with-icon-layout-header-icon-${layoutType}`
              )}>
              {character}
            </div>
            <h4
              className={classnames(headerTitleClassName, 'dialog-with-icon-layout-header-title', {
                'no-content': noContent,
              })}>
              {header || <>&nbsp;</>}
            </h4>
          </div>
        </>
      }
      contentClassName={classnames(contentClassName, 'dialog-with-icon-layout-content-wrapper')}>
      {children}
    </GeneralDialogLayout>
  );
}

DialogsWithIcon.propTypes = {
  character: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  layoutType: PropTypes.oneOf(['error', 'info', 'question', 'success']),
  headerClassName: PropTypes.string,
  footerClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  headerTitleClassName: PropTypes.string,
  headerTitleIconClassName: PropTypes.string,
  noBorder: PropTypes.bool,
  noContent: PropTypes.bool,
  header: PropTypes.any,
  children: PropTypes.node,
  preHeader: PropTypes.node,
};
